/**
 * @generated SignedSource<<9b1ff78498ece5a66e0967d04c244204>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type breadcumbTreeMenuQuery$variables = {
  lastUsedTool: number;
};
export type breadcumbTreeMenuQuery$data = {
  readonly treeMenu: string;
};
export type breadcumbTreeMenuQuery = {
  response: breadcumbTreeMenuQuery$data;
  variables: breadcumbTreeMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastUsedTool"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lastUsedTool",
        "variableName": "lastUsedTool"
      }
    ],
    "kind": "ScalarField",
    "name": "treeMenu",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "breadcumbTreeMenuQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "breadcumbTreeMenuQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "f7280750a51e9c80b86357fb48eb6be1",
    "id": null,
    "metadata": {},
    "name": "breadcumbTreeMenuQuery",
    "operationKind": "query",
    "text": "query breadcumbTreeMenuQuery(\n  $lastUsedTool: Int!\n) {\n  treeMenu(lastUsedTool: $lastUsedTool)\n}\n"
  }
};
})();

(node as any).hash = "1751627631d09b25c6c3f3c816fef336";

export default node;
